import { createContext, useContext } from 'react'

/**
 * The add-on packs this installation runs — IMPLEMENTATION.md decisions 26 and 27.
 *
 * Read from the signed-in principal and provided once at the top of the
 * application, so a guideline screen can describe the Snapshot Evaluator as the
 * pack to add or as the pack already here without every page fetching it. The
 * default is a base installation, which is also what a component rendered on its
 * own — in a test — sees.
 */
export const SNAPSHOT_EVALUATOR = 'snapshot_evaluator'

export const AddOnsContext = createContext<string[]>([])

export function useEvaluatorPack(): boolean {
  return useContext(AddOnsContext).includes(SNAPSHOT_EVALUATOR)
}
